import { materialClassService } from '_services';
import { session } from '_helpers';
import { ACTIONS_MATERIAL_CLASS } from '_constants/materialClass.constants';
import alertActions from './alert.actions';

export const receiveMaterialClasses = (materialClasses) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < materialClasses.length; i++) {
    byIdObjectToDispatch[materialClasses[i].materialClassID] = materialClasses[i];
  }

  return {
    type: ACTIONS_MATERIAL_CLASS.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

export const deleteMaterialClass = (materialClassId) => ({
  type: ACTIONS_MATERIAL_CLASS.DELETE,
  byId: { [materialClassId]: null }
});

const getMaterialClasses = (accountID) => async (dispatch) => {
  try {
    const resp = await materialClassService.getAll(accountID);
    if (resp?.[0]?.materialClassID) {
      dispatch(receiveMaterialClasses(resp));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error('Error retrieving material classes.'));
  }
  return null;
};

const getMaterialClass = (materialClassID) => async (dispatch) => {
  try {
    const resp = await materialClassService.getById(materialClassID);
    if (resp?.materialClassID) {
      dispatch(receiveMaterialClasses([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error retrieving material class #${materialClassID}.`));
  }
  return null;
};

const addMaterialClass = (materialClass) => async (dispatch) => {
  try {
    const resp = await materialClassService.create(materialClass);
    if (resp?.materialClassID) {
      dispatch(receiveMaterialClasses([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const updMaterialClass = (materialClass) => async (dispatch) => {
  try {
    const resp = await materialClassService.update(materialClass);
    if (resp?.materialClassID) {
      dispatch(receiveMaterialClasses([ resp ]));
      return resp;
    }
  } catch (e) {
    console.error(e);
    session.checkSession(e);
    dispatch(alertActions.error(e.message));
  }
  return null;
};

const delMaterialClass = (materialClassID) => async (dispatch) => {
  try {
    const resp = await materialClassService.delete(materialClassID);
    if (resp?.materialClassID) {
      dispatch(deleteMaterialClass(resp.materialClassID));
      return resp;
    }
  } catch (e) {
    console.error(e);
    dispatch(alertActions.error(`Error removing material class #${materialClassID}.`));
  }
  return null;
};

const materialClassActions = {
  getMaterialClasses,
  getMaterialClass,
  addMaterialClass,
  updMaterialClass,
  delMaterialClass
};

export default materialClassActions;
